const LABELS = {
  mostDots: "Dot King YTD",
  rdDots: "Rd Dot Leader",
  hot: "Hot",
  parInKing: "Par In King",
  trapper: "Rabbit King",
};

export const Badge = ({ type }) => (
  <span
    data-testid={`badge-${type}`}
    className="rounded-sm border border-cypress-gold/50 bg-cypress-gold/10 px-1.5 py-px text-[9px] font-bold uppercase tracking-wider text-cypress-gold"
  >
    {LABELS[type] || type}
  </span>
);
